import CryptoJS from 'crypto-js';
import { auth } from '../config';

export function censorWord(str) {
    if (str) {
        if (str?.length < 2) {
            return str;
        }
        return str[0] + "*".repeat(str.length - 2) + str.slice(-1);
    }
}

export function censorPhone(number) {
    return censorWord(number);
}

export function censorEmail(email) {
    if (email) {
        var arr = email.split("@");
        return censorWord(arr[0]) + "@" + censorWord(arr[1]);
    }
}

export function encode(data) {
    if (data) {
        const encryptedData = CryptoJS.AES.encrypt(data, `${auth.jwt}`).toString();
        return encryptedData;
    } else {
        return null;
    };
};


export function decode(data) {
    if (data) {
        let bytes = CryptoJS.AES.decrypt(data, `${auth.jwt}`);
        let decodedData = bytes.toString(CryptoJS.enc.Utf8);
        return decodedData;
    } else {
        return null;
    };
};